import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const FreeAd = ({code}) => {
  const { t } = useTranslation('common')

  return (
    <div className='registracija-content-success-msg'>
      {t('Vaš BESPLATAN oglas')} {code} {t('je uspješno poslat i čeka potvrdu administratora!')}
    </div>
  )
}

FreeAd.propTypes = {
  code: PropTypes.string.isRequired
}
